import { Box, TextField, Button, Select, MenuItem, Table, TableBody, TableRow, TableCell, TableContainer, TableHead, FormControl, Stack, Pagination, FormControlLabel, Checkbox } from '@mui/material'
import React, { useEffect, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation, useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ModalUpdateData from 'components/modal/healthPromotion/ModalUpdateData';
import ModalDeleteName from 'components/modal/healthPromotion/ModalDeleteName';
import * as api from '../services/api'
import Loader from 'components/Loader';
import add from '../../assets/icons/add_white.svg'
import { StackedBarChartProject, StackedLineChartProject } from 'components/StackedBarChart';
import { useSelector } from 'react-redux';

function ListOfAllParticipants() {
  const auth = useSelector((state) => state.auth.user_data)
  const location = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const [maxPage, setMaxPage] = useState(1)
  const [showList, setShowList] = useState([])

  const [role, setRole] = useState(auth['permission']['group_code'])
  const [departmentCode, setDepartmentCode] = useState(auth['department']?.['department_code'])
  const [departmentName, setDepartmentName] = useState(auth['department']?.['department_name'])

  const [department, setDepartment] = useState('')
  const [optionDepartment, setOptionDepartment] = useState([])

  const [ageRange, setAgeRange] = useState('')
  const [optionAge, setOptionAge] = useState([])

  const [year, setYear] = useState(location.state.year)
  const [projectCode, steProjectCode] = useState(location.state.code)
  const [detailItem, setDetailItem] = useState([])

  const [headerKeyBegin, setHeaderKeyBegin] = useState([])
  const [headerKeyCurrent, setHeaderKeyCurrent] = useState([])

  const [openModalUpdate, setOpenModalUpdate] = useState(false)
  const [openModalDelete, setOpenModalDelete] = useState(false)

  const [graphDepartment, setGraphDepartment] = useState('')
  const [optionGraphDepartment, setOptionGraphDepartment] = useState([])

  const [compare, setCompare] = useState(location.state.targetList[0])
  const [optionCompare, setOptionCompare] = useState([])

  const [dataGraph, setDataGraph] = useState([])

  const date = location.state.date

  const options = [
    'อัพเดทข้อมูล',
    'นำรายชื่อออก'
  ];
  const ITEM_HEIGHT = 3;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    age()
    findDepartment()

    let targ = location.state.targetList
    setOptionCompare(targ)
    setCompare(targ[0])
  }, [])

  useEffect(() => {
    memberGraph()
  }, [graphDepartment, compare])

  useEffect(() => {
    memberList()
  }, [ageRange, department, page])

  useEffect(() => {
    setPage(1)
  }, [ageRange, department, search])

  const handlePageChange = (event, page) => {
    setPage(page)
  }

  const handleClick = (event, item) => {
    setDetailItem(item)
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickOption = (e) => {
    let { textContent } = e.target
    if (textContent == 'อัพเดทข้อมูล') {
      setOpenModalUpdate(true)
    } else {
      setOpenModalDelete(true)
    }
    setAnchorEl(null);
  };

  const handleClickSearch = () => {
    memberList()
  }

  const getValueAndResultKeys = (dataArray, text) => {
    if (text == 'begin') {
      const keySet = new Set();
      dataArray.forEach(obj => {
        Object.keys(obj).forEach(key => {
          if (key.includes('_begin')) {
            keySet.add(key);
          }
        });
      });
      return Array.from(keySet);
    } else {
      const keySet = new Set();
      dataArray.forEach(obj => {
        Object.keys(obj).forEach(key => {
          if (key.includes('_current')) {
            keySet.add(key);
          }
        });
      });
      return Array.from(keySet);
    }

  };

  const memberList = async () => {
    setLoading(true)
    let res = await api.memberList(location.state.year, projectCode, page, ageRange, role === 'G-0010' ? department == 'null' ? '' : department : departmentCode)
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        let data = res['data']['data']
        setShowList(data)

        const keyBegin = getValueAndResultKeys(data, 'begin');
        setHeaderKeyBegin(keyBegin)
        // console.log(keyBegin)

        const keyCurrent = getValueAndResultKeys(data, 'current');
        setHeaderKeyCurrent(keyCurrent)
        // console.log(keyCurrent)

        let pag = res['data']['pagging']
        setPage(pag['page'])
        setMaxPage(pag['totalPage'])
      } else if (res['data']['code'] === 999) {
        console.log(res['data']['message'])
        setShowList([])
      } else {
        setShowList([])
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const findDepartment = async () => {
    setLoading(true)
    let res = await api.findDepartmentFixToken()
    setLoading(false)
    if (res) {
      if (res['data']['code'] == 200) {
        let data = res['data']['data']

        let option = []
        data.forEach((item) => {
          const code = item?.department_code;
          const name = item?.department_name;
          if (code && name) {
            option.push({ key: code, value: name });
          }
        });

        const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
        setOptionDepartment(unique)
        setOptionGraphDepartment(unique)
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const age = async () => {
    setLoading(true)
    let res = await api.age()
    setLoading(false)
    if (res) {
      if (res['data']['code'] == '200') {
        let data = res['data']['data']
        setOptionAge(data)
      } else {
        //alert(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  }

  const convertDate = (dataDate) => {
    const date = new Date(dataDate)
    const optionDate = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }
    const thaiLocale = 'th-TH';
    const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

    const newDate = `${formattedDate}`
    return newDate
  }

  const percentageCal = (begin, current) => {
    if (begin !== '' && current !== '') {
      const sum = ((current - begin) / begin) * 100
      return Number.isInteger(sum) ? sum + '%' : sum.toFixed(2) + '%'
    } else {
      return '-'
    }
  }

  const handleClickExport = async () => {
    setLoading(true)
    let res = await api.exportExcel(departmentCode, projectCode, year)
    setLoading(false)
    if (res) {
      if (res['data']['code'] == '200') {
        let data = res['data']['data']['file_url']
        // console.log(data)
        window.open(data, '_blank')
      } else {
        //alert(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  }

  const memberGraph = async () => {
    setLoading(true)
    let res = await api.memberGraph(projectCode, compare, graphDepartment == 'null' ? '' : graphDepartment)
    setLoading(false)
    if (res) {
      if (res['data']['code'] == '200') {
        setDataGraph(res['data']['data']['graph'])
      } else {
        //alert(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  }

  return (
    <>
      {openModalUpdate ?
        <ModalUpdateData
          onClose={() => { setOpenModalUpdate(false) }}
          data={detailItem}
          onSubmit={() => {
            memberList()
            memberGraph()
          }}
        />
        : null
      }
      {openModalDelete ?
        <ModalDeleteName
          onClose={() => { setOpenModalDelete(false) }}
          data={detailItem}
          onSubmit={() => {
            memberList()
            memberGraph()
          }}
        />
        : null
      }
      <Loader loading={loading} />

      <Box sx={{ display: 'grid', gridGap: '10px' }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gridGap: '10px'
        }}>
          <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
          <Box sx={{
            cursor: 'pointer'
          }}
            onClick={() => { navigate('/managePromote') }}
          >กลับไป จัดการงานสร้างเสริม</Box>
        </Box>

        <Box sx={{
          fontWeight: 600,
          color: "#478F96",
          "@media (max-width: 800px)": {
            textAlign: "center",
          },
        }}>รายชื่อผู้เข้าร่วม {location.state.name}</Box>

        <Box sx={{
          border: '1px solid #478F96',
          borderRadius: '10px',
          padding: '20px',
          display: 'grid',
          gridGap: '10px'
        }}>
          <Box sx={{
            fontWeight: 600,
            "@media (max-width: 800px)": {
              textAlign: "center",
            },
          }}>ค้นหาด้วยชื่อ</Box>
          <Box sx={{
            border: '1px solid #478F96',
            borderRadius: '10px',
            display: 'flex',
            padding: '5px'
          }}>
            <TextField
              fullWidth
              variant="standard"
              sx={{
                ...InputCSS
              }}
              InputProps={{
                disableUnderline: true,
              }}
              placeholder="พิมพ์ข้อความเพื่อค้นหาข้อมูล..."
              value={search}
              onChange={(e) => { setSearch(e.target.value) }}
            />
            <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
          </Box>

          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            "@media (max-width: 800px)": {
              display: 'grid',
              gridGap: '10px'
            },
          }}>
            <Box sx={{
              display: 'flex',
              gridGap: '10px'
            }}>
              <Box>
                <Box sx={{ fontWeight: 500 }}>สังกัด</Box>

                {role === 'G-0010' ?
                  <Select
                    size="small"
                    sx={{ ...SelectCss }}
                    value={department || 'null'}
                    onChange={(e) => { setDepartment(e.target.value) }}
                  >
                    <MenuItem value="null">ทั้งหมด</MenuItem>
                    {optionDepartment.map((i, idx) => (
                      <MenuItem key={idx} value={i['key']}>{i['value']}</MenuItem>
                    ))}
                  </Select>
                  :
                  <TextField
                    fullWidth
                    size="small"
                    sx={{ ...SelectCss }}
                    value={departmentName}
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                }

              </Box>
              <Box>
                <Box sx={{ fontWeight: 500 }}>เลือกช่วงอายุ</Box>
                <Select
                  size="small"
                  sx={{ ...SelectCss }}
                  value={ageRange || 'ALL'}
                  onChange={(e) => {
                    if (e.target.value === 'ALL') {
                      setAgeRange('')
                    } else {
                      setAgeRange(e.target.value)
                    }
                  }}
                >
                  {optionAge.map((i, idx) => (
                    <MenuItem key={idx} value={i['name']} >{i['value']}</MenuItem>
                  ))}
                </Select>
              </Box>

            </Box>

            <Box sx={{
              display: 'flex',
              gridGap: '10px',
              alignItems: 'end',
            }}>
              <Box>
                <Button
                  variant='contained'
                  sx={{ background: '#C8EBEB', color: '#478F96' }}
                  onClick={() => { handleClickExport() }}
                >
                  Export
                </Button>
              </Box>
              <Box>
                {/* <Button
                  variant='contained'
                  sx={{ display: 'flex', gridGap: '10px' }}
                >
                  <img src={add} style={{ width: '20px' }} />
                  <div>เพิ่มผู้เข้าร่วม</div>
                </Button> */}
              </Box>
            </Box>
          </Box>

          <Box sx={{
            overflow: 'auto'
          }}>
            <TableContainer sx={{ maxHeight: '700px' }}>
              <Table sx={{ minWidth: '1500px' }}>
                <TableHead sx={{ backgroundColor: '#C8EBEB' }}>
                  <TableRow>
                    <TableCell rowSpan={2} sx={{ minWidth: '150px' }}>วันที่เข้าร่วม</TableCell>
                    <TableCell rowSpan={2}>ยศ</TableCell>
                    <TableCell rowSpan={2} align='center' sx={{ minWidth: '180px' }}>ชื่อ-นามสกุล</TableCell>
                    <TableCell rowSpan={2} align='center' width={'150px'}>เลขบัตรประชาชน</TableCell>
                    <TableCell rowSpan={2} align='center'>อายุ</TableCell>
                    <TableCell rowSpan={2} align='center'>สังกัด</TableCell>
                    <TableCell colSpan={headerKeyBegin.length} align='center'>ค่าเริมต้น</TableCell>
                    <TableCell colSpan={headerKeyCurrent.length} align='center'>ข้อมูลอัพเดทล่าสุด</TableCell>

                    {headerKeyBegin.includes('weight_begin') &&
                      <TableCell rowSpan={2} align='center' sx={{ minWidth: '110px' }}>อัตราน้ำหนัก</TableCell>
                    }

                    <TableCell rowSpan={2} align='center' sx={{ minWidth: '100px' }}>ตัวเลือก</TableCell>
                  </TableRow>
                  <TableRow>
                    {headerKeyBegin.map((key, idx) => (
                      <TableCell align='center' key={idx}>{key}</TableCell>
                    ))}
                    {headerKeyCurrent.map((key, idx) => (
                      <TableCell align='center' key={idx}>{key}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {showList.length > 0 ? (
                    showList.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{convertDate(item['join_date'])}</TableCell>
                        <TableCell>{item['pname']}</TableCell>
                        <TableCell>{item['fname'] + ' ' + item['lname']}</TableCell>
                        <TableCell>{item['pid']}</TableCell>
                        <TableCell>{item['age']}</TableCell>
                        <TableCell>{item['department_name_short']}</TableCell>

                        {headerKeyBegin.map((key, idx) => (
                          <TableCell align='center' key={idx}>{item[key] && item[key].trim() !== '' ? item[key] : '-'}</TableCell>
                        ))}
                        {headerKeyCurrent.map((key, idx) => (
                          <TableCell align='center' key={idx}>{item[key] && item[key].trim() !== '' ? item[key] : '-'}</TableCell>
                        ))}

                        {headerKeyBegin.includes('weight_begin') &&
                          <>
                            {item['weight_begin'] ?
                              <TableCell align='center'>{percentageCal(item['weight_begin'], item['weight_current'])}</TableCell>
                              :
                              <TableCell align='center'>-</TableCell>
                            }
                          </>
                        }


                        <TableCell align='center'>
                          <>
                            <IconButton
                              aria-label="more"
                              id="long-button"
                              aria-controls={open ? 'long-menu' : undefined}
                              aria-expanded={open ? 'true' : undefined}
                              aria-haspopup="true"
                              onClick={(event) => { handleClick(event, item) }}
                            >
                              <MoreVertIcon />
                            </IconButton>
                            <Menu
                              id="long-menu"
                              MenuListProps={{
                                'aria-labelledby': 'long-button',
                              }}
                              anchorEl={anchorEl}
                              open={open}
                              onClose={handleClose}
                              slotProps={{
                                paper: {
                                  style: {
                                    minHeight: ITEM_HEIGHT * 4.5,
                                    width: '20ch',
                                    boxShadow: '1px 3px 5px rgba(168, 168, 168, 0.1)',
                                  },
                                },
                              }}
                            >
                              {options.map((option) => (
                                <MenuItem key={option} onClick={handleClickOption}>
                                  <div style={option === 'นำรายชื่อออก' ? { color: '#E06262' } : {}}>{option}</div>
                                </MenuItem>
                              ))}
                            </Menu>
                          </>
                        </TableCell>
                      </TableRow>
                    ))
                  )
                    :
                    (
                      <TableRow>
                        <TableCell colSpan='10'>
                          <Box sx={{ textAlign: 'center' }}>ไม่มีข้อมูล</Box>
                        </TableCell>
                      </TableRow>
                    )
                  }

                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box sx={{
            display: 'flex',
            justifyContent: 'end',
            margin: 2
          }}>
            <Stack spacing={2}>
              <Pagination
                count={maxPage}
                page={page}
                onChange={handlePageChange}
                shape="rounded"
                color="primary"
              />
            </Stack>
          </Box>

          <Box sx={{
            display: 'grid',
            gridGap: '15px'
          }}>
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between'
            }}>
              <Box sx={{
                display: 'flex',
                gridGap: '10px'
              }}>
                <Box>
                  <Box>เลือกสังกัด (สำหรับกราฟ)</Box>
                  <Select
                    fullWidth
                    size="small"
                    sx={{ ...SelectCss }}
                    value={graphDepartment || 'null'}
                    onChange={(e) => { setGraphDepartment(e.target.value) }}
                  >
                    <MenuItem value="null">ทั้งหมด</MenuItem>
                    {optionGraphDepartment.map((i, idx) => (
                      <MenuItem key={idx} value={i['key']}>{i['value']}</MenuItem>
                    ))}
                  </Select>
                </Box>
                <Box>
                  <Box>เลือกรายการตรวจ</Box>
                  <Select
                    fullWidth
                    size="small"
                    sx={{ ...SelectCss }}
                    value={compare || 'null'}
                    onChange={(e) => { setCompare(e.target.value) }}
                  >
                    <MenuItem value="null" disabled>เลือก</MenuItem>
                    {optionCompare.map((i, idx) => (
                      <MenuItem key={idx} value={i}>{i}</MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
            </Box>

            <Box>
              <Box>
                <StackedLineChartProject
                  inform={dataGraph['tracking'] ? dataGraph['tracking'] : []}
                  color={dataGraph['color']}
                  type={compare}
                  date={date}
                  summary={dataGraph['summary']}
                  total={dataGraph['total']}
                />
              </Box>
              <Box>
                <StackedBarChartProject
                  inform={dataGraph['tracking'] ? dataGraph['tracking'] : []}
                  color={dataGraph['color']}
                  type={compare}
                  date={date}
                  summary={dataGraph['summary']}
                  total={dataGraph['total']}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default ListOfAllParticipants

const InputCSS = {
  padding: '5px',
  border: 'none',
  '&.MuiInputBase-root': {
    border: 'none'
  },
  '&.MuiInputBase-root:focus': {

  }
}

const SelectCss = {
  backgroundColor: '#C8EBEB',
  border: 'none',
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
}
